import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import ReactTooltip from 'react-tooltip';

import Navbar from '../shared/Navbar';
import Footer from './Footer';
import Section from './Section';
import Island from '../shared/Island';
import Title from '../shared/Title';
import Text from '../shared/Text';
import { breakpoints, palette } from '../../constants/styles';
import ScrollToTopOnMount from '../shared/ScrollToTopOnMount';

import Icon from '../shared/Icon';
import { StyledDivision } from '../shared/resultsStyles';

const StyledConocenos = styled.div`
  position: relative;
  overflow: hidden;
`;

const StyledMission = styled.div`
  margin-bottom: 20px;
  text-align: center;
  max-width: 615px;
`;

const StyledAdvisorsSection = styled(Section)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px 40px 20px 40px;

  ${breakpoints.tablet} {
    margin-top: 20px;
  }

  ${breakpoints.tabletLandscape} {
    margin-top: 50px;
  }

  ${breakpoints.desktop} {
    margin-top: 90px;
  }
`;

const FAImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 70%;

  ${breakpoints.mobileLandscape} {
    width: 40%;
  }
`;
const FAImage = styled.img`
  width: 100%;
  height: auto;
  margin-right: 20px;
  margin-left: 20px;
  margin-bottom: 10px;
  max-width: 140px;
  max-height: 170px;

  ${breakpoints.mobileLandscape} {
    max-height: 210px;
  }

  ${breakpoints.mobileLandscape} {
    max-width: 180px;
  }
`;

const FADescription = styled.div`
  width: 100%;
  padding-top: 10px;

  ${breakpoints.mobileLandscape} {
    width: 60%;
    margin: 10% 25px;
  }

  ${breakpoints.tablet} {
    margin: 10px 25px;
  }
`;

const FACredentials = styled.div`
  margin-top: 15px;
  text-align: left;
  font-weight: 500;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const StyledAdvisorsList = styled.ul`
  list-style-type: none;
  width: 100%;
  margin: 0;
  padding: 0;

  ${breakpoints.mobileLandscape} {
    & :nth-child(even) {
      flex-direction: row;
      & ${FAImage} {
        margin-right: 30px;
        margin-left: 30px;
      }

      & ${FAImageContainer} {
        flex-direction: column;
      }
    }
    & :nth-child(odd) {
      & ${FAImage} {
        margin-right: 30px;
        margin-left: 30px;
      }

      & ${FADescription} {
        text-align: right;
      }

      & ${FACredentials} {
        text-align: right;
      }

      & ${FAImageContainer} {
        flex-direction: column;
      }

      flex-direction: row-reverse;
    }
  }
  max-width: 700px;

  ${breakpoints.desktop} {
    max-width: 900px;
  }
`;

const StyledFinancialAdvisor = styled.li`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  list-style-type: none;
  width: 100%;
  margin: 3rem 0 0 0;
  padding: 0;
  margin-bottom: 20px;
`;

export const FinancialAdvisorsInfo = [
  {
    name: 'Javier Sinco',
    imageLink: 'https://s3.us-east-2.amazonaws.com/finauta/avatars/equipo/SincoExperto.jpg',
    position: 'AFC',
    positionDescription: 'Asesor Financiero Certificado',
    description:
      'Mi pasión está en ayudar a la gente a lograr lo que se propongan. Mi enfoque ha sido en instrumentos de ahorro e inversión. Tengo 3 perros y juego basquetbol.',
    education: 'Lic. Economía',
    credentials: [
      {
        name: 'AMIB-3',
        description:
          'Asesor en Estrategias de Inversión emitido por la Asociación Mexicana de Intermediarios Bursátiles (AMIB)',
      },
      {
        name: 'NAP',
        description:
          'Agente Promotor emitido por la Comisión Nacional del Sistema de Ahorro para el Retiro (CONSAR)',
      },
      {
        name: 'A-CNSF',
        description:
          'Asesor de Seguros emitido por la Comisión Nacional de Seguros y Fianzas (CNSF)',
      },
    ],
  },
  {
    name: 'Arizbeth Barrueta',
    imageLink: 'https://s3.us-east-2.amazonaws.com/finauta/avatars/equipo/Ariz.jpg',
    position: 'AFC',
    positionDescription: 'Asesor Financiero Certificado',
    description:
      'Llevo una década asesorando clientes y lo disfruto mucho. Mi enfoque es en comparación de productos bancarios, seguros y pensiones. Lo mío es el Yoga, la fotografía y el vino.',
    education: 'Lic. Administración',
    credentials: [
      {
        name: 'AMIB-1',
        description:
          'Promotor de Sociedades de Inversión emitido por la Asociación Mexicana de Intermediarios Bursátiles (AMIB)',
      },
      {
        name: 'A-CNSF',
        description:
          'Asesor de Seguros emitido por la Comisión Nacional de Seguros y Fianzas (CNSF)',
      },
      {
        name: 'NAP',
        description:
          'Agente Promotor emitido por la Comisión Nacional del Sistema de Ahorro para el Retiro (CONSAR)',
      },
    ],
  },
  {
    name: 'Víctor Rojas',
    imageLink: 'https://s3.us-east-2.amazonaws.com/finauta/avatars/equipo/Victor.jpg',
    position: 'AFC',
    positionDescription: 'Asesor Financiero Certificado',
    description:
      'Tengo más de 10 años ayudando a la gente a lograr sus objetivos financieros. Mi enfoque es en estrategias de inversión. Me encanta el futbol, soy Puma de corazón.',
    credentials: [
      {
        name: 'AMIB-3',
        description:
          'Asesor en Estrategias de Inversión emitido por la Asociación Mexicana de Intermediarios Bursátiles (AMIB)',
      },
      {
        name: 'NAP',
        description:
          'Agente Promotor emitido por la Comisión Nacional del Sistema de Ahorro para el Retiro (CONSAR)',
      },
      {
        name: 'A-CNSF',
        description:
          'Asesor de Seguros emitido por la Comisión Nacional de Seguros y Fianzas (CNSF)',
      },
    ],
  },
  {
    name: 'Gabriela Godínez',
    imageLink: 'https://s3.us-east-2.amazonaws.com/finauta/avatars/equipo/Gaby.jpg',
    position: 'AFC',
    positionDescription: 'Asesor Financiero Certificado',
    description:
      'Me apasionan los mercados financieros y los deportes. Mi enfoque es en casa de bolsa, mercado de capitales y deuda. Soy amante de los perros y del futbol.',
    credentials: [
      {
        name: 'AMIB-3',
        description:
          'Asesor en Estrategias de Inversión emitido por la Asociación Mexicana de Intermediarios Bursátiles (AMIB)',
      },
    ],
  },
  {
    name: 'Emiliano Martinez',
    imageLink: 'https://s3.us-east-2.amazonaws.com/finauta/avatars/equipo/Emiliano.jpg',
    position: 'AFC',
    positionDescription: 'Asesor Financiero Certificado',
    description:
      'Me dedico la asesoría y educación financiera de personas físicas y emprendedores. Me enfoco en soluciones empresariales y valuación de proyectos. Me encantan los deportes y bailo de todo.',
    credentials: [
      {
        name: 'AMIB-3',
        description:
          'Asesor en Estrategias de Inversión emitido por la Asociación Mexicana de Intermediarios Bursátiles (AMIB)',
      },
    ],
  },
];

const FoundersInfo = [
  {
    name: 'Oscar Gonzalez',
    imageLink: 'https://s3.us-east-2.amazonaws.com/finauta/avatars/equipo/Oscar.jpg',
    position: 'Co-Fundador, Co-CEO',
    linkedin: 'https://www.linkedin.com/in/oscargzzguerra',
    description:
      'Para mí Finauta es empoderar a la gente en su toma de decisiones financieras. Me hace feliz saber que con cada decisión estamos mejorando el bienestar de nuestros usuarios y sus familias.',
  },
  {
    name: 'Javier Sinco',
    imageLink: 'https://s3.us-east-2.amazonaws.com/finauta/avatars/equipo/Sinco.jpg',
    position: 'Co-Fundador, Co-CEO',
    linkedin: 'https://www.linkedin.com/in/javier-sinco-15a53286',
    description:
      'Finauta representa mis ganas de ayudar, compartir y crecer. Busco que todos encuentren las estabilidad financiera que buscan y no tengan miedo a ir por lo que quieren.',
  },
  {
    name: 'Emilio Gonzalez',
    imageLink: 'https://s3.us-east-2.amazonaws.com/finauta/avatars/equipo/Emilio.jpg',
    position: 'Co-Fundador, CTO',
    linkedin: 'https://www.linkedin.com/in/emiliogzzguerra',
    description:
      'Para mí Finauta es una oportunidad de ayudar a quienes tal vez ni siquiera saben que necesitan ayuda. Me hace múy feliz saber que nuestro esfuerzo está mejorando la calidad de vida de nuestros usuarios.',
  },
];

const StyledFoundersList = styled.ul`
  list-style-type: none;
  width: 100%;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;

  ${breakpoints.tabletLandscape} {
    flex-direction: row;
    justify-content: center;
  }
`;

const StyledFounder = styled.li`
  display: flex;
  flex-direction: column;
  align-items: center;
  list-style-type: none;
  width: 100%;
  margin: 3rem 0 0 0;
  padding: 0;
  margin-bottom: 20px;

  ${breakpoints.tabletLandscape} {
    max-width: 350px;
  }

  ${breakpoints.desktop} {
    max-width: 400px;
  }
`;

const FounderImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Founderimage = styled.img`
  width: 100%;
  height: auto;
  max-width: 140px;
  margin-bottom: -30px;

  ${breakpoints.tablet} {
    max-width: 180px;
  }
`;

const FounderDescription = styled.div`
  width: 100%;
  max-width: 350px;
  padding-top: 10px;
  max-width: 300px;

  ${breakpoints.tabletLandscape} {
    max-width: 200px;
  }

  ${breakpoints.desktop} {
    max-width: 300px;
  }

  ${breakpoints.tablet} {
    font-size: 18px;
  }

  ${breakpoints.desktop} {
    font-size: 20px;
  }
`;

const StyledLinkedInIconFounder = styled.a`
  position: relative;
  top: -20px;
  right: -70px;
`;

const StyledUnderline = css`
  font-size: 1.8rem;
  text-shadow: 0px 0px white, 0px 0px white, 2px -2px white, 0px 0px white;
  background-size: 1px 1em;
  box-shadow: inset 0 -0.175em white, inset 0 -0.2em #000;
  display: inline;
  box-shadow: inset 0 -0em white, inset 0 -0.1em ${palette.secondaryColor};
  line-height: 1.65;
`;

const StyledPurpose = css`
  margin-top: 15px;
`;

const StyledPositionTitle = css`
  margin-bottom: 5px;
`;

class Conocenos extends Component {
  state = {
    displayThumbnail: true,
  };

  render() {
    return (
      <StyledConocenos>
        <ScrollToTopOnMount />

        <Navbar />
        <StyledAdvisorsSection>
          <Title level={2}>Nuestra misión:</Title>
          <StyledMission>
            <Title
              level={1}
              color={palette.primaryColor}
              medium
              align="center"
              styles={StyledUnderline}
            >
              Que tú logres tus metas financieras
            </Title>
            <Text type="body2" styles={StyledPurpose} align="left">
              En Finauta, creemos que las relaciones personales son clave para navegar exitosamente
              en el mar de las finanzas personales.
            </Text>
            <Text type="body2" styles={StyledPurpose} align="left">
              Para nosotros es importante conocerte y asegurarnos que nuestras recomendaciones estén
              alineadas con tu contexto.
            </Text>
            <Text type="body2" styles={StyledPurpose} align="left">
              Proteger tus intereses es nuestro valor principal.
            </Text>
            {/*
            <StyledSignature>
              <StyledSignatureImage src="https://s3.us-east-2.amazonaws.com/finauta/avatars/equipo/OscarFirma.png" />
              <Title level={5} medium>
                Oscar Gonzalez
              </Title>
              <StyledPosition>
                Co-founder, Co-CEO
              </StyledPosition>
            </StyledSignature>f
            */}
          </StyledMission>
          <StyledDivision />
          <Title level={2} align="center">
            Conoce a los expertos
          </Title>
          <StyledAdvisorsList>
            <ReactTooltip className="styled-tooltip" />
            {FinancialAdvisorsInfo.map((FA, i) => (
              <StyledFinancialAdvisor key={FA.name.concat(i)}>
                <FAImageContainer>
                  <FAImage src={FA.imageLink} />
                  <Title level={5} align="center" styles={StyledPositionTitle}>
                    {FA.name},{' '}
                    <span data-tip={FA.positionDescription} style={{ display: 'inline-block' }}>
                      {FA.position}
                      <Icon
                        icon="moreInfo"
                        color="#1d2d35"
                        size={13}
                        style={{ marginLeft: '3px' }}
                      />
                    </span>
                  </Title>
                </FAImageContainer>
                <FADescription>
                  <Text type="body1">{FA.description}</Text>

                  <FACredentials>
                    <span style={{ marginRight: '0.5rem' }}>Certificaciones:</span>
                    {FA.credentials.map((credential, j) => (
                      <Text
                        type="credential"
                        tip={credential.description}
                        key={credential.description.concat(j)}
                        styles={css`
                          font-weight: 500;
                        `}
                      >
                        {credential.name}
                      </Text>
                    ))}
                  </FACredentials>
                </FADescription>
              </StyledFinancialAdvisor>
            ))}
          </StyledAdvisorsList>
          <StyledDivision />
          <Title level={2} align="center">
            Fundadores
          </Title>
          <StyledFoundersList>
            {FoundersInfo.map((Founder, i) => (
              <StyledFounder key={Founder.name.concat(i)}>
                <FounderImageContainer>
                  <Founderimage src={Founder.imageLink} />
                  <StyledLinkedInIconFounder href={Founder.linkedin} target="_blank">
                    <Icon icon="linkedinLink" size={45} />
                  </StyledLinkedInIconFounder>
                  <Title level={5} align="center" styles={StyledPositionTitle}>
                    {Founder.name}
                  </Title>
                  <Title level={6} align="center" medium>
                    {Founder.position}
                  </Title>
                </FounderImageContainer>
                {/*
                  <Credentials>
                    {Founder.credentials.map(cred => (
                      <Credential>
                        <StyledCredentialLink data-tip data-for={cred.name}>
                          <img src={cred.icon} style={{ height: '30px', width: '30px' }} role="presentation" />
                        </StyledCredentialLink>
                      </Credential>
                    ))}
                  </Credentials>
                */}
                <FounderDescription>
                  <Text type="body1">{Founder.description}</Text>
                </FounderDescription>
              </StyledFounder>
            ))}
          </StyledFoundersList>
        </StyledAdvisorsSection>
        <Footer />
      </StyledConocenos>
    );
  }
}

Conocenos.propTypes = {};

export default Conocenos;
